import React, { useEffect, useState } from 'react'
import api from '../components/api';
import { useHistory } from 'react-router-dom'
import Residuos_TabelaGestao from '../components/Residuos_TabelaGestao'


const ResiduosSSInfo = (props) => {


    const history = useHistory()

    var adesao_institucional_id = props.match.params.adesao_institucional_id


    var [cnpj, setCNPJ] = useState()
    var [razao_social, setRazaoSocial] = useState()
    var [nome_fantasia, setNomeFantasia] = useState()
    
    
    
    

    async function carregaDados() {


        if (adesao_institucional_id) {


            await api.get(`adesaoInstitucionalListaUm/${adesao_institucional_id}`).then((result) => {
            //console.log(result.data, '!!')
    
            var data = result.data[0]
            //console.log(data)
    
            setRazaoSocial(data.razao_social)
            setNomeFantasia(data.nome_fantasia)
            setCNPJ(data.cnpj)
            
            /*
            
            setNomePessoaPreenche(data.nome_pessoa_preenche)
            setCargoPessoaPreenche(data.cargo_pessoa_preenche)
            setTelefonePessoaPreenche(data.telefone_pessoa_preenche)
            setCategoriaAdesao(data.categoria_adesao)
            setOrganizacaoAmbitoId(data.organizacao_ambito_id)
            setOrganizacaoEspecId(data.organizacao_espec_id)
            setOrganizacaoId(data.organizacao_id)
            setPorteOrganizacao(data.porte_organizacao)
            */
            
            }).catch((err) => {
                console.log(err.response)
            })

        }



    }




    useEffect(() => {

        carregaDados()


    }, [])

    return (
        <div>

            <div className='content-header'>
                <div className='header-icon'>
                    <i className='pe-7s-trash'></i>
                </div>
                <div className='header-title'>
                    <h1>Resíduos SS</h1>
                    <small>Administração</small>
                    
                </div>

            </div>

            <div className='row'>

                <div className="col-md-3">
                    <div className="form-group">
                        <label>CNPJ</label>
                        <input type="text" className="form-control" placeholder="" value={cnpj} style={{ cursor: 'pointer' }} onClick={() => history.push(`/AdesaoInstitucional/${adesao_institucional_id}`)} readOnly />
                                        
                    </div>
                </div>
                
                
                <div className="col-md-9">
                    <div className="form-group">
                        <label>Nome Fantasia</label>
                        <input type="text" className="form-control" placeholder="" value={nome_fantasia} readOnly />
                        
                    </div>
                </div>


                <div className="col-md-12">


                    


                </div>
                

            </div>


            <Residuos_TabelaGestao adesao_institucional_id={adesao_institucional_id} />


            <div class="col-md-12">

                <br/>
                <center>
                <button type="button" class="btn btn-info" onClick={() => history.push(`/ResiduosSS`)}>Voltar</button>&nbsp;
                </center>    
                
            </div>



            


        </div>
    )

}

export default ResiduosSSInfo